import api from '../../api/index'
class NetworkMonitor {
  constructor() {
    this.online = null
    this.onOnlineCallback = null
    this.onOfflineCallback = null
    this.reconnectInterval = 5000 // 重连间隔时间，单位毫秒
    this.reconnectTimer = null

    window.addEventListener('online', () => this.handleNetworkChange(true))
    window.addEventListener('offline', () => this.handleNetworkChange(false))
  }

  // 设置在线回调函数
  onOnline(callback) {
    this.onOnlineCallback = callback
  }

  // 设置离线回调函数
  onOffline(callback) {
    this.onOfflineCallback = callback
  }

  // 更新网络状态
  updateNetworkStatus(online) {
    if (online === this.online) return
    this.online = online
    if (online && this.onOnlineCallback) {
      this.onOnlineCallback()
    } else if (!online && this.onOfflineCallback) {
      this.onOfflineCallback()
    }

    // 在线时清除重连定时器
    if (online && this.reconnectTimer) {
      clearInterval(this.reconnectTimer)
      this.reconnectTimer = null
    }
  }

  handleNetworkChange(online) {
    if (!online) {
      // 再请求一次，确认下
      this.checkNetworkStatus(online)
    }
  }

  // 检测当前是否在线
  async checkNetworkStatus(online, reConnect = false) {
    const params = {}
    if (reConnect) {
      params.reConnect = true
    }
    // 未登录时，这个接口会返回401，所以这里需要判断一下
    if (localStorage.getItem('me')) {
      api.call('GET', '/user/me', params, (response) => {
        if (response.status == 200) {
          this.updateNetworkStatus(true)
        } else {
          this.updateNetworkStatus(false)
          // 断线后启动重连定时器
          this.startReconnectTimer()
        }
      })
    } else {
      this.updateNetworkStatus(online)
    }
  }

  // 启动断线重连定时器
  startReconnectTimer() {
    if (!this.reconnectTimer) {
      this.reconnectTimer = setInterval(() => {
        this.checkNetworkStatus(false, true)
      }, this.reconnectInterval)
    }
  }

  // 销毁
  destroy() {
    window.removeEventListener('online', () => this.handleNetworkChange(true))
    window.removeEventListener('offline', () => this.handleNetworkChange(false))

    // 清除重连定时器
    if (this.reconnectTimer) {
      clearInterval(this.reconnectTimer)
      this.reconnectTimer = null
    }
  }
}

export default new NetworkMonitor()
